<div class="program-item">

  <div class="inner-wrapper">
    <div class="info">
      <div class="title"> {{ this.title }} </div>

      <div class="btn-wrapper" *ngIf="this.share" (click)="presentSharePopover($event)">
        <button class="btn green-btn">
          {{ 'loyaltyProgram.shareBtn'|transloco }}
          <img alt="Referral program" class="share-img" src="assets/images/icons/share_white.svg" />
        </button>
      </div>


    </div>

    <div class="image">
      <img alt="Referral program" src="assets/images/programs/{{ this.type}}.png" />
    </div>

  </div>


  <div class="grey-line"></div>

  <div class="details inner-wrapper" (click)="openProgramInfoModal()">
    <div>  {{ 'loyaltyProgram.details'|transloco }}</div>
    <div>
      <img alt="coins" src="assets/images/icons/arrow_right_green.svg" />
    </div>
  </div>

</div>
